import { BrowserRouter, Route, Routes as RRDRoutes } from 'react-router-dom';

import { EquipmentCollectionPage } from '../../modules/collection/pages/collection';
import { FinishCollectionOrder } from '../../modules/collection/pages/finishCollectionOrder';
import { CollectionSelectPatientsPage } from '../../modules/collection/pages/selectPatient';
import { ConfigurationPage } from '../../modules/configuration/pages/configuration';
import { KpiPage } from '../../modules/reports/pages/kpi';
import { LoginPage } from '../../modules/auth/pages/login';
import { MainPage } from '../../modules/dashboard/pages/main';
import { FinishOrder } from '../../modules/orders/pages/newOrderFlow/finish';
import { OrderSelectArea } from '../../modules/orders/pages/newOrderFlow/orderSelectArea';
import { OrderSelectCategory } from '../../modules/orders/pages/newOrderFlow/selectCategory';
import { SelectPatient } from '../../modules/orders/pages/newOrderFlow/selectPatient';
import { OrderSelectSubCategory } from '../../modules/orders/pages/newOrderFlow/selectSubCategory';
import { OrdersPage } from '../../modules/orders/pages/orders';
import { PatientsPage } from '../../modules/patients/pages/patients';
import { PatientsV2Page } from '../../modules/patients/pages/patientsv2Page';
import { PatientV2DetailsPage } from '../../modules/patients/pages/patientsv2DetailsPage';
import { PatientV2CreatePage } from '../../modules/patients/pages/patientsv2CreatePage';
import { PatientV2AccessRoute } from '../../modules/patients/pages/PatientV2AccessRoute';
import { RechargeConfirmationPage } from '../../modules/recharge/pages/confirmation';
import { FinishRechargerOrder } from '../../modules/recharge/pages/finishRechargerOrder';
import { RechargeSelectPatientsPage } from '../../modules/recharge/pages/selectPatient';
import { SharedLinkPage } from '../../modules/shared-link/pages/sharedLink';
import { TechnicalAssistancePage } from '../../modules/technical-assistance/pages/assistance';
import { FinishAssistanceOrder } from '../../modules/technical-assistance/pages/finishAssistanceOrder';
import { TechnicalAssistanceSelectPatientsPage } from '../../modules/technical-assistance/pages/selectPatient';
import { PrivacyPage } from '../../modules/auth/pages/privacyTerm';
import { PrivateRoute } from './PrivateRoute';
import SSOCallback from '../../modules/auth/pages/ssoCallback';
import { ConfigureEquipmentRouter } from '../../modules/orders/pages/newOrderFlow/configureEquipmentRouter';
import { ConfigureEquipmentMockup } from '../../modules/orders/pages/newOrderFlow/configureEquipmentMockup';
import ConfigureEquipmentMockup2 from '../../modules/orders/pages/newOrderFlow/configureEquipmentMockup/ConfigureEquipmentMockup2';
import ConfigureEquipmentMockup3 from '../../modules/orders/pages/newOrderFlow/configureEquipmentMockup/ConfigureEquipmentMockup3';

import {
  SalesCatalogPage,
  SuballocationCatalogPage,
} from '../../modules/sales/pages/catalog';
import {
  FinishSalesOrder,
  FinishSuballocationOrder,
} from '../../modules/sales/pages/finishSalesOrder';
import {
  SalesSelectPatientPage,
  SuballocationSelectPatientPage,
} from '../../modules/sales/pages/selectPatient';
import { BasketManagerPage } from '../../modules/basket/pages/basketManager';

export const Routes = () => {
  return (
    <BrowserRouter>
      <RRDRoutes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/link" element={<SharedLinkPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sso/callback" element={<SSOCallback />} />
        <Route path="/verify" element={<LoginPage />} />
        <Route path="/recovery" element={<LoginPage />} />
        <Route path="/email-confirm-signup" element={<LoginPage />} />
        <Route path="/email-reset-password" element={<LoginPage />} />
        <Route path="/email-verify-attribute" element={<LoginPage />} />
        <Route element={<PrivateRoute />}>
          <Route path="/order/newOrder" element={<OrderSelectArea />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/sales/selectPatient"
            element={<SalesSelectPatientPage />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route path="/sales/catalog" element={<SalesCatalogPage />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route path="/sales/finish" element={<FinishSalesOrder />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/suballocation/selectPatient"
            element={<SuballocationSelectPatientPage />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/suballocation/catalog"
            element={<SuballocationCatalogPage />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/suballocation/finish"
            element={<FinishSuballocationOrder />}
          />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/order/finish" element={<FinishOrder />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/configuration" element={<ConfigurationPage />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/recharge/finishRecharge"
            element={<FinishRechargerOrder />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/recharge/confirmRecharge"
            element={<RechargeConfirmationPage />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/recharge/rechargePatient"
            element={<RechargeSelectPatientsPage />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/collectEquipments/finishCollectEquipments"
            element={<FinishCollectionOrder />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/collectEquipments/collectEquipments"
            element={<EquipmentCollectionPage />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/collectEquipments/collectFromPatient"
            element={<CollectionSelectPatientsPage />}
          />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route
            path="/technicalAssistance/finishAssistanceOrder"
            element={<FinishAssistanceOrder />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/technicalAssistance/assistance"
            element={<TechnicalAssistancePage />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/technicalAssistance/assistanceToPatient"
            element={<TechnicalAssistanceSelectPatientsPage />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route path="/order/selectPatient" element={<SelectPatient />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/order/selectSubCategory"
            element={<OrderSelectSubCategory />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/order/configureEquipment"
            element={<ConfigureEquipmentRouter />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/order/configureEquipmentMockup"
            element={<ConfigureEquipmentMockup />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/order/configureEquipmentMockup2"
            element={<ConfigureEquipmentMockup2 />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/order/configureEquipmentMockup3"
            element={<ConfigureEquipmentMockup3 />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/order/selectCategory"
            element={<OrderSelectCategory />}
          />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/privacyTerm" element={<PrivacyPage />} />
        </Route>
        {/*<Route element={<PrivateRoute />}>
          <Route path="/main" element={<MainPage />} />
        </Route>*/}
        <Route element={<PrivateRoute />}>
          <Route path="/patients" element={<PatientsPage />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route element={<PatientV2AccessRoute />}>
            <Route path="/patientsv2" element={<PatientsV2Page />} />
            <Route path="/patientsv2/new" element={<PatientV2CreatePage />} />
            <Route path="/patientsv2/:patientId/review" element={<PatientV2DetailsPage mode="review" />} />
            <Route path="/patientsv2/:patientId" element={<PatientV2DetailsPage />} />
          </Route>
        </Route>
        <Route element={<PrivateRoute />}>
          <Route path="/report" element={<KpiPage />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route path="/orders" element={<OrdersPage />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route path="/baskets" element={<BasketManagerPage />} />
        </Route>
      </RRDRoutes>
    </BrowserRouter>
  );
};
